var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTaginline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.868 17.629"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "etiqueta (1)",
    d: "M18.382 8.516l-.338 1.69a2.353 2.353 0 01-1.131 1.577l-9.583 5.53a2.355 2.355 0 01-3.217-.867L.313 9.87a2.355 2.355 0 01.869-3.213l9.577-5.529A2.356 2.356 0 0112.69.936l1.632.551a4.3 4.3 0 114.087 7.024h-.028zm-4.864-5.641l-1.336-.451a.784.784 0 00-.644.064L1.964 8.017a.785.785 0 00-.287 1.073l3.8 6.576a.785.785 0 001.073.287l9.577-5.529a.784.784 0 00.377-.526l.993-4.957a.786.786 0 00-.519-.9l-1.968-.665a2.724 2.724 0 00.006 1.857.785.785 0 01-1.474.543 4.294 4.294 0 01-.02-2.9zm2.494-.815l1.465.5a2.356 2.356 0 011.555 2.686l-.3 1.516a2.69 2.69 0 00.206-.108 2.726 2.726 0 00-2.726-4.722 3.3 3.3 0 00-.2.128z",
    fillRule: "evenodd",
    fill: "currentColor"
  })));
}

export default SvgTaginline;